import { PopupState } from './types';

const initialState: PopupState = {
  open: undefined,
  data: undefined,
};

export default initialState;
